import {Injectable, NgZone} from '@angular/core';
import {Observable} from 'rxjs';
import {ServerSentEventService} from './server-sent-event.service';

@Injectable({
  providedIn: 'root'
})
export class EventMessageService {

  constructor(private serverSentEventService: ServerSentEventService, private zone: NgZone) {
  }

  getServerSentEvent(url: URL) {
    return new Observable(observer => {
      const eventSource = this.serverSentEventService.getEventSource(url);

      eventSource.onmessage = event => {
        this.zone.run(() => {
          observer.next(event);
        });
      };

      eventSource.onerror = error  => {
        this.zone.run(() => {
          observer.error(error);
        });
      };
    });
  }
}
